/**
 * Basic Wrapper to allow a custom element pull in a webpack ng-include html like the standard ng include
 * To ensure there is no confusion usage is distinctly different
 * <div template-include include-name="header"></div>
 *
 * Note that webpack parses the require statement on building so dynamic ones like this
 * <div template-include include-url="RelativePathFromThisDirective/template.html"></div>
 * whilst most flexible will cause overhead and issues if you leave all folders open as possible includes like this require("../"+attr.includeUrl);
 * https://webpack.github.io/docs/context.html
 *
 * For now static paths are required
 *
 * @returns {function(): {restrict: string, templateUrl: function(Element, Attributes): (boolean|string)}}
 */

var getTemplateDirective = function () {
  //noinspection JSUnresolvedFunction,NpmUsedModulesInstalled
  var urls = {
    "app.header": require("app/templates/partials/header.html"),
    "app.footer": require("app/templates/partials/footer.html"),
    "app.hmr.accept.modal": require("features/referral/templates/partials/accept.html"),
    "app.hmr.error.modal": require("features/referral/templates/partials/error.html"),
    "app.hmr.original-referral.modal": require("features/referral/templates/partials/original-referral.html"),
    "app.hmr.refund-request.modal": require("features/referral/templates/partials/refund-request.html"),
    "app.hmr.submit.modal": require("features/referral/templates/partials/submit.html"),
    "app.hmr.supporting-files.modal": require("features/referral/templates/partials/supporting-files.html"),
    "app.account.modal": require("features/account/templates/partials/modal.html"),
    "app.support": require("app/templates/partials/support.html"),
    "admin.clinic.api-key.modal": require("admin/templates/partials/api-key-modal.html"),
    "admin.hmr.refund-request.modal": require("features/referral/templates/partials/refund-request.html"),
    "admin.menu": require("admin/templates/partials/menu.html"),
  };

  return function templateInclude() {
    return {
      restrict: "A",
      templateUrl: function (elem, attr) {
        if (!attr.hasOwnProperty("includeName") || !urls[attr.includeName]) {
          return false;
        }
        else {
          return urls[attr.includeName];
        }
      }
    };
  };
};

export default angular.module("directives.templateInclude", [])
  .directive("templateInclude", getTemplateDirective())
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/template.directive.js
 **/